import Buttons from 'components/molecules/buttons';
import { CSSProperties, ReactNode } from 'react';
import { IChildrenProp } from 'types/components/components.interface';
import './PublicPageTemplate.scss';

interface IPublicPageTemplateProps extends IChildrenProp {
  header?: ReactNode;
  footer?: ReactNode;
  creative?: ReactNode;
  wrapperContentStyle?: CSSProperties;
  withConsent?: boolean;
}

const PublicPageTemplate = ({
  header,
  children,
  creative,
  footer,
  withConsent = true,
  wrapperContentStyle,
}: IPublicPageTemplateProps) => {
  return (
    <div className='public-page-wrapper'>
      <div className='public-page-top'>
        <Buttons.PublicConfiguration />
      </div>
      <div
        className={`public-page-template ${creative ? 'with-creative' : ''}`}>
        {creative && <div className='creative'>{creative}</div>}
        {(header || children || footer) && (
          <div style={wrapperContentStyle} className='public-page'>
            {header && <div className='header'>{header}</div>}
            <div className='content'>{children}</div>
            {footer && <div className='footer'>{footer}</div>}
          </div>
        )}
      </div>
    </div>
  );
};

export default PublicPageTemplate;
